export const LEVEL_COMPLETE_BANNER = {
  QUALIFYING: {
    title: "Associate Level Achieved",
    getMessage: completionDate =>
      `You completed the Qualifying Level${completionDate ? ` on ${completionDate}` : ""}`,
  },
  DEFAULT: {
    getTitle: levelName => `${levelName} Complete`,
    getMessage: (levelName, completionDate) =>
      `Congratulations, you're making great progress. You completed ${levelName}${completionDate ? ` on ${completionDate}` : ""}.`,
  },
}
